import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const LINES = [
  { lead: "We design.", tail: "We engineer." },
  { lead: "We ship.", tail: "We scale." },
];

function Line({ data, index, total, progress }) {
  const start = (index / total) * 0.85;
  const end = ((index + 1) / total) * 0.85;
  const opacity = useTransform(progress, [start, start + 0.05, end - 0.05, end], [0.15, 1, 1, 0.5]);
  const x = useTransform(progress, [start, end], [-20, 0]);
  return (
    <motion.h2
      style={{ opacity, x }}
      className="font-display font-black tracking-[-0.04em] text-[12vw] sm:text-6xl md:text-8xl lg:text-[8vw] leading-[0.95] flex flex-col sm:flex-row sm:flex-wrap items-start sm:items-baseline gap-x-6 gap-y-1 sm:gap-y-2"
    >
      <span className="text-white">{data.lead}</span>
      <span className="text-white/35 italic font-light">{data.tail}</span>
    </motion.h2>
  );
}

export default function ManifestoStrip() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const lineScale = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section ref={ref} className="relative py-24 md:py-40 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 md:gap-4 mb-8 md:mb-10">
          <motion.span
            style={{ scaleX: lineScale, originX: 0 }}
            className="h-px bg-gradient-to-r from-[#0A84FF] to-transparent flex-1 max-w-[80px] md:max-w-[140px]"
          />
          <span className="text-[10px] md:text-xs font-bold uppercase tracking-[0.3em] text-[#0A84FF]">
            Manifesto · 002
          </span>
        </div>
        <div className="space-y-5 sm:space-y-6 md:space-y-8">
          {LINES.map((l, i) => (
            <Line key={l.lead} data={l} index={i} total={LINES.length} progress={scrollYProgress} />
          ))}
        </div>
      </div>
    </section>
  );
}
